import { pdpSectionStyle } from 'common/components/page-section/pdp-styles';
import { styled } from 'linaria/react';
import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { getSeoTextHTML } from 'features/page-model';

export type BottomD9nSectionState = {
  seoTextHTML?: string;
};

export type BottomD9nSectionProps = BottomD9nSectionState & React.HTMLAttributes<HTMLElement>;

export const BottomD9nSection: React.FC<BottomD9nSectionProps> = ({ seoTextHTML, className, ...props }) => {
  return (
    <BottomD9nSectionContainer className={className} {...props} data-qa="pdp-section-seo-block">
      <BottomD9nSectionContent
        className={pdpSectionStyle}
        dangerouslySetInnerHTML={{ __html: seoTextHTML ?? '' }}
      />
    </BottomD9nSectionContainer>
  );
};

const BottomD9nSectionContainer = styled.section`
  width: 100%;
  background-color: rgb(241, 241, 241);
`;

const BottomD9nSectionContent = styled.section`
  padding: 30px;
  margin-top: 0;
  background-color: #ffffff;

  h2 {
    margin: 6px 0 8px;
    font-size: 16px;
    line-height: 21px;
    color: rgb(102, 102, 102);
  }

  p {
    font-size: 12px;
    line-height: 20px;
    color: #666;
  }

  a {
    text-decoration: underline;
    color: var(--brand-dark);
  }
`;

function mapStateToProps(state: RootState): BottomD9nSectionState {
  const seoTextHTML = getSeoTextHTML(state);

  return {
    seoTextHTML,
  };
}

export const PdpBottomD9nSectionState = connect(mapStateToProps)(BottomD9nSection);
